import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box } from 'reflexbox/styled-components'

import media from 'media'

export const logoShape = {
  image: PropTypes.node,
  className: PropTypes.string,
  url: PropTypes.string,
}

const getLogoContainerAttrs = ({ redesign }) => ({
  mr: [redesign ? 10 : 20, redesign ? 10 : 20, redesign ? 32 : 20],
  ml: redesign ? 0 : 20,
  my: 18,
})

export const LogoContainer = styled(Box)
  .attrs(getLogoContainerAttrs)
  .withConfig({
    shouldForwardProp: (prop) => ['redesign'].indexOf(prop) === -1,
  })`
  img,
  .gatsby-image-wrapper img {
    height: 30px;

    opacity: 1;

    ${media.tablet`
      height: 40px;
    `}

    ${media.desktop`
      height: 45px;
    `}

    ${media.giant`
      height: 50px;
    `}
  }

  // TODO: should respond to different # of logos
  ${({ redesign }) =>
    redesign &&
    `
    flex-basis: 25%;
    svg {
      width: auto !important;
    }
  `}

  ${media.giant`
    flex-basis: unset;
  `}
`

export const getLogo = (
  logo,
  logoContainerComponent = LogoContainer,
  logoWidth,
  logoProps = {}
) => {
  const Container = logoContainerComponent
  return (
    <Container
      key={logo.alt || logo.title || logo?.className}
      className={logo?.className}
      width={logoWidth}
      {...logoProps}
    >
      {logo?.getImage ? (
        logo.getImage()
      ) : (
        <img
          src={logo.logo}
          title={logo.alt || logo?.title}
          alt={logo.alt || logo?.title}
          className={logo?.className}
        />
      )}
    </Container>
  )
}
